import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=63cfa8c8&scoped=true"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"
import style0 from "./OverlayLoading.vue?vue&type=style&index=0&id=63cfa8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cfa8c8",
  null
  
)

export default component.exports